module.exports = __webpack_public_path__ + "img/dp-down-arrow.6589fe31.svg";